export default __webpack_public_path__ + "static/media/Whenthemessageshouldpop-up.4a34774e.svg";